import React from 'react';
import { VertButton as AntButton, Spin } from '@vertem-core/vertice-ds';
import { ButtonProps } from 'antd/lib/button';

interface ButtonLargeProps
  extends Omit<ButtonProps, 'size' | 'onClick' | 'shape' | 'type'> {
  loading?: boolean;
  shape?: 'default' | 'round';
  size?: 'default' | 'small' | 'large';
  type?: 'default' | 'link' | 'highlight';
  onClick?: () => void;
}

const ButtonLarge: React.FC<ButtonLargeProps> = ({
  loading,
  size,
  type,
  onClick,
  ...props
}) => {
  const mappedSize = size === 'default' ? 'default' : size;

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <AntButton
      {...props}
      className={`button-fml pwa-button ${props.className || ''}`}
      size={mappedSize}
      type={type}
      onClick={handleClick}
      disabled={loading || props.disabled}
    >
      {loading ? <Spin /> : props.children}
    </AntButton>
  );
};

export default ButtonLarge;
